// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_dJ7","cls2":"LoggedInDiscoveryPage-cls2_VKR LoggedInDiscoveryPage-cls1_dJ7"};